/* ============
 * Tax Transformer
 * ============
 */
import moment from 'moment';
import Transformer from './transformer';

export default class ExcisePeriodTransformer extends Transformer {

  static fetch(period) {
    return {
      id: period.id,
      calendarMonth: period.calendar_month,
      monthName: moment(period.calendar_month).format('YYYY/MM'),
      exciseStatusId: period.excise_status_id,
      exciseStatus: period.excise_status,
      closedAt: period.closed_at,
    };
  }

  static send(period) {
    return {
      id: period.id,
      calendar_month: period.calendarMonth,
      excise_status_id: period.exciseStatusId,
      excise_status: period.exciseStatus,
      closed_at: period.closedAt,
    };
  }
}



// WEBPACK FOOTER //
// ./src/app/transformers/excisePeriod.js